/* eslint-disable import/no-cycle */
import * as React from 'react';
import {useContext, useState} from 'react';
import {observer} from 'mobx-react-lite';
import InspectionTaskBox from './InspectionTaskBox';
import {StoreContext} from '../../../stores/rootStore';
import {useMount} from '../../../hooks/useMount';

const InspectionTaskExecutions = ({inspectionTask, disabled, pendingOnly = true, useUniformQualityIndicator}) => {
  const store = useContext(StoreContext);
  const [tasks, setTasks] = useState([]);
  const [openId, setOpenId] = useState();

  const openNext = (currentId) => {
    setOpenId(tasks.find((result) => result.id > currentId)?.id);
  };

  useMount(() => {
    setTasks(store.inspectionTaskStore.getSameGroup(inspectionTask, pendingOnly));
  }, [inspectionTask]);

  useMount(() => {
    if (tasks.length > 0) {
      setOpenId(tasks[0].id);
    }
  }, [tasks]);

  return (
    <>
      {tasks.map((task) => (
        <InspectionTaskBox
          key={task.id}
          inspectionTask={task}
          openId={openId}
          openNext={openNext}
          disabled={disabled}
          useUniformQualityIndicator={useUniformQualityIndicator}
        />
      ))}
    </>
  );
};
export default observer(InspectionTaskExecutions);
